export enum MediaEntityType {
    Compliance = 'Compliance',
    Job = 'Job',
    WorkOrder = 'WorkOrder',
    Code = 'Code',
    None = 'None'
}


export enum ModuleSource {
    JobManager = 'Job Manager',
    Claim = 'Claim',
    MergeTemplate = 'Merge Templates'
}

export interface JobMediaMetadata {
    readonly: boolean;
    entityId: string;
    entityName: string;
    entityType: MediaEntityType;
    excludes: string[];
    timezone: string;
    refresh?: boolean;
    options?: any[];
    source?: ModuleSource;
    workOrderId?: string;
}